// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const runsApiAdvisorRunsGetParamsScopeDefault = `mine`;
export const runsApiAdvisorRunsGetParamsStatusOneMax = 20;

export const runsApiAdvisorRunsGetParamsQOneMax = 200;

export const runsApiAdvisorRunsGetParamsPageDefault = 1;

export const runsApiAdvisorRunsGetParamsPageSizeDefault = 25;
export const runsApiAdvisorRunsGetParamsPageSizeMax = 100;

export const RunsApiAdvisorRunsGetParams = zod.object({
  "scope": zod.enum(['mine', 'all']).default(runsApiAdvisorRunsGetParamsScopeDefault),
  "status": zod.union([zod.string().max(runsApiAdvisorRunsGetParamsStatusOneMax),zod.null()]).optional(),
  "q": zod.union([zod.string().max(runsApiAdvisorRunsGetParamsQOneMax),zod.null()]).optional(),
  "page": zod.int().min(1).default(runsApiAdvisorRunsGetParamsPageDefault),
  "page_size": zod.int().min(1).max(runsApiAdvisorRunsGetParamsPageSizeMax).default(runsApiAdvisorRunsGetParamsPageSizeDefault)
})

export type RunsApiAdvisorRunsGetParams = zod.input<typeof RunsApiAdvisorRunsGetParams>;
export type RunsApiAdvisorRunsGetParamsOutput = zod.output<typeof RunsApiAdvisorRunsGetParams>;
